export enum CheckoutRoute {
    PAYMENTS = "show-payments",
    PAYMENTS_INDEX = "show-payments",
    ADD_NEW_CARD = "add-new-card",
    VPA_TIMER = "vpa-timer",
    PAYMENT_TXN_STATUS_POLLING = "payment-txn-status-polling",
    CONFIRM_ORDER = "confirm-order",
    DIRECT_PLACE_ORDER = "direct-place-order",
    MORE_BANKS = "more-banks",
    VERIFY_WALLET_LINK_OTP = "verify-wallet-link-otp",
    LINK_WALLET_WITH_NUMBER = "link-wallet-with-number",
    VERIFY_VPA = "verify-vpa",
    LINK_PAYLATER = "link-paylater",
    LINK_PAYLATER_MOBILE = "link-paylater-mobile",
    REDIRECT_PAGE = "redirect-page",
    MORE_PAYMENT_GROUPS = "more-payment-groups",
    MORE_PAYMENT_METHODS = "more-payment-methods",
    CART = "show-cart",
    ADD_SWIGGY_MONEY = "add-swiggy-money",
    ADD_SWIGGY_MONEY_INDEX = "add-swiggy-money",
    SWIGGY_MONEY_PAYMENTS = "swiggy-money-payments",
    COUPON_LISTING = "coupon-listing",
    PAYMENT_OFFERS = "payment-offers",
    DINEOUT_PAYMENT_SUCCESS = "dineout-payment-success",
    DINEOUT_SUCCESS_SCREEN = "DINEOUT_SUCCESS_SCREEN",
    DINEOUT_DIRECT_PLACE_ORDER = "dineout-direct-checkout",

    // payment modes routes
    PAYMENT_MODES_INDEX = "payment-modes",
    PAYMENT_MODES_ADD_NEW_CARD = "payment-modes-add-new-card",
    MANAGE_CARD = "manage-card",
    SECURE_CARD = "secure-card",
    CONFIRM_TRANSACTION = "confirm-transaction",
    PENNY_TXN_STATUS_POLLER = "penny-txn-status-poller",
    PAYMENT_MODES_VERIFY_WALLET_LINK_OTP = "payment-modes-verify-wallet-link-otp",
    PAYMENT_MODES_LINK_WALLET_WITH_NUMBER = "payment-modes-link-wallet-with-number",
    LINK_WALLET_INDEX = "link-wallets",
    WALLET_DETAILS = "wallet-detail",
    PAYLATER_LINKING_CONFIRMATION = "paylater-linking-confirmation",

    // autopay
    AUTOPAY_ELIGIBLE_PAYMENT_FAILED = "autopay-eligible-payment-failed",

    //turbo-pay
    TURBO_PAY = "turbo-pay",
    TURBO_PLACE_ORDER = "turbo-place-order",

    // group-order
    SHARED_CART = "shared-cart",

    // gifting
    GIFTING_CART = "show-gifting-cart",
    GIFTING_COUPON_LISTING = "show-gifting-coupon-listing",

    // toing
    TOING_CART = "show-toing-cart",

    // MRO (Multi-Restaurant Order) food cart
    MRO_FOOD_CART = "show-mro-food-cart",
    MRO_FOOD_COUPON_LISTING = "show-mro-food-coupon-listing",

    // emi selection
    EMI_SELECTION = "emi-selection",
    REVIEW_ORDER_DETAILS = "review-order-details",
    STEAL_STORE_CART = "steal-store-cart",

    // quick checkout
    QUICK_CHECKOUT = "quick-checkout",
}

export enum DineoutCheckoutRoute {
    PAYMENTS = "show-payments",
    PAYMENTS_INDEX = "show-payments",
    ADD_NEW_CARD = "add-new-card",
    VPA_TIMER = "vpa-timer",
    PAYMENT_TXN_STATUS_POLLING = "payment-txn-status-polling",
    CONFIRM_ORDER = "confirm-order",
    DIRECT_PLACE_ORDER = "direct-place-order",
    MORE_BANKS = "more-banks",
    VERIFY_WALLET_LINK_OTP = "verify-wallet-link-otp",
    LINK_WALLET_WITH_NUMBER = "link-wallet-with-number",
    VERIFY_VPA = "verify-vpa",
    LINK_PAYLATER = "link-paylater",
    LINK_PAYLATER_MOBILE = "link-paylater-mobile",
    REDIRECT_PAGE = "redirect-page",
    MORE_PAYMENT_GROUPS = "more-payment-groups",
    MORE_PAYMENT_METHODS = "more-payment-methods",
    CART = "show-dineout-cart",
    ADD_SWIGGY_MONEY = "add-swiggy-money",
    ADD_SWIGGY_MONEY_INDEX = "add-swiggy-money",
    SWIGGY_MONEY_PAYMENTS = "swiggy-money-payments",
    DINEOUT_DIRECT_FREE_RESERVATION = "dineout-direct-free-reservation",
    PAYMENT_OFFERS = "payment-offers",
    COUPON_LISTING = "coupons-listing",
    DINEOUT_PAYMENT_SUCCESS = "dineout-payment-success",

    DINEOUT_DIRECT_PLACE_ORDER = "dineout-direct-checkout",

    BILL_PAYMENT_CART = "bill-payment-cart",
    /* for table reservation, these 2 are kept separate and decoupled to make
     * to app compatible also, since on app we might go with just reservation
     * cart for now, and migrate inventory page later on */
    TABLE_RESERVATION_CART = "table-reservation-cart",

    SCENES_FULL_PAYMENT = "scenes-full-payment",
    STEAL_STORE_CART = "steal-store-cart",
    DINE_CASH_POOLING = "dine-cash-pooling",
}
